var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderprocess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0259 3.89106L17.6591 4.51401L13.8435 8.32959L13.0259 3.89106ZM7.57509 16.3501L2.94189 15.7271L6.75747 11.9116L7.57509 16.3501ZM4.07099 7.39516L4.69394 2.76196L8.50952 6.57754L4.07099 7.39516Z",
    fill: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57726 9.03046L2.94201 9.34194C2.90308 9.61448 2.90308 9.84808 2.90308 10.1206C2.90308 11.9116 3.52603 13.6247 4.69406 14.9485L5.86209 13.9362C4.9666 12.885 4.46045 11.5223 4.46045 10.1206C4.46045 9.77021 4.49939 9.38087 4.57726 9.03046ZM10.3006 2.72308C8.19816 2.72308 6.32931 3.61858 4.9666 5.02021L6.05677 6.11038C7.14693 4.98128 8.62644 4.28046 10.3006 4.28046C10.651 4.28046 11.0404 4.31939 11.3908 4.39726L11.6633 2.87882C11.235 2.76202 10.7678 2.72308 10.3006 2.72308ZM16.024 11.2108L17.6592 10.8993C17.6982 10.6268 17.6982 10.3932 17.6982 10.1206C17.6982 8.40751 17.1141 6.73333 16.024 5.40956L14.817 6.38292C15.6736 7.43415 16.1408 8.75792 16.1408 10.0817C16.1408 10.471 16.1018 10.8604 16.024 11.2108ZM14.5445 14.1309C13.4543 15.26 11.9748 15.9608 10.3006 15.9608C9.95021 15.9608 9.56086 15.9219 9.21045 15.844L8.93791 17.3624C9.40513 17.4403 9.87234 17.4792 10.3006 17.4792C12.4031 17.4792 14.2719 16.5837 15.6346 15.1821L14.5445 14.1309Z",
    fill: "#E5E5E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5301 12.846L15.9071 17.4792L12.0916 13.6636L16.5301 12.846Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderprocess);
export default __webpack_public_path__ + "static/media/orderprocess.f62a20e37e5ad4bbe08e6810c5b0864d.svg";
export { ForwardRef as ReactComponent };